import { React, useState } from "react";

import "../../../WorkSpace/SignUp2.css";
import { useHistory } from "react-router";
import { findLeasesAccount, GetLease } from "../ApiServices/apiHandler";
import { toast } from "react-toastify";
import swal from "sweetalert";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import registerscss from "../../../myfin_v2/css/registers.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import { Button, IconButton } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as RadioChecked } from "../../../myfin_v2/assets/icons/radio_checked.svg";
import { ReactComponent as RadioUnchecked } from "../../../myfin_v2/assets/icons/radio_unchecked.svg";


const RegisterModal = (props) => {
  let history = useHistory();
  let permissions = JSON.parse(localStorage.getItem('permission'));
  const { activePlandata } = props;
  const user_id = localStorage.getItem("user_id");



  const { registerModalOpen, handleRegisterModalClose, continueStep } = props;
  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (reg) => {
    setSelectedValue(reg);
  };

  const Chnageradiofunction = async () => {
    try {
      if (selectedValue === "d") {
        // Restriction check for lease account creation
        try {
          const res = await findLeasesAccount(user_id);
          const leaseFromPlan = res.data?.leases; // Lease limit from plan

          if (leaseFromPlan) {
            try {
              const leaseRes = await GetLease();
              const leaseData = leaseRes.data?.projects?.length;

              if (leaseData >= leaseFromPlan) {
                swal(
                  "Warning",
                  "Lease limit has been reached.Please contact your admin",
                  "warning"
                );
                return;
              }
            } catch (err) {
              const errMsg = err?.message || "Internal Server Error";
              toast(errMsg);
              return;
            }
          }
        } catch (err) {
          const errMsg = err?.response?.data?.error || "Internal Server Error";
          toast(errMsg);
          return;
        }
      }

      const links = {
        a: () => {
          if (
            permissions?.companyData?.[0]?.components?.[1]?.permission?.create !== false ||
            permissions === null
          ) {
            continueStep();
          }
        },
        b: () => document.getElementById("linkB")?.click(),
        c: () => document.getElementById("linkC")?.click(),
        d: () => document.getElementById("linkD")?.click(),
        e: () => document.getElementById("linkE")?.click(),
        f: () => document.getElementById("linkF")?.click(),
        g: () => document.getElementById("linkG")?.click(),
        h: () => document.getElementById("linkH")?.click(),
      };

      links[selectedValue]?.();
    } catch (error) {
      console.error("Error in Chnageradiofunction:", error);
    }
  };

  return (
    <>
      <Modal
        width={"44%"}
        minHeight={"350px"}
        title="Create Register"
        bodycss={commoncss.unsetPadding}
        headerActions={
          <>

            <CloseIcon
              onClick={() => {
                handleRegisterModalClose();
              }}
              className="clickable"
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
        footerActions={
          <>
            <span></span>
            <span >
              &ensp;
              <Button
                btnColor={buttoncss.primary}
                label="Proceed"
                onClick={() => {
                  history.push(`/createregister/${selectedValue}`);
                }}
              />
            </span>
          </>
        }
      >
        <div className={commoncss.pd1530}>
          <>
            <div className={registerscss.guidingTextCR}>
              Choose a register type to proceed with the setup. Ensure you have the required access permissions.
            </div>
            <div className={`${registerscss.createRegistersGrid} my-4`} style={{ padding: "0px" }}>
              {activePlandata?.includes('Investment') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Investment' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Investment' ? '' : 'Investment') }}>
                    <span className={commoncss.label6}>Investments</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Investment' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Investments</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}

              {activePlandata?.includes('Loans') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Loan' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Loan' ? '' : 'Loan') }}>
                    <span className={commoncss.label6}>Loans</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Loan' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Loans</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}

              {activePlandata?.includes('Purchases') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Purchase' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Purchase' ? '' : 'Purchase') }}>
                    <span className={commoncss.label6}>Purchase</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Purchase' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Purchases</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}


              {activePlandata?.includes('Leases') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Lease' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Lease' ? '' : 'Lease') }}>
                    <span className={commoncss.label6}>Lease</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Lease' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Lease</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}

              {activePlandata?.includes('Fixed Assets') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Fixed Assets' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Fixed Assets' ? '' : 'Fixed Assets') }}>
                    <span className={commoncss.label6}>Fixed Assets</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Fixed Assets' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Fixed Assets</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}

              {activePlandata?.includes('Receivables') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Receivable' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Receivable' ? '' : 'Receivable') }}>
                    <span className={commoncss.label6}>Receivable</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Receivable' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Receivable</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}

              {activePlandata?.includes('Payables') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Payable' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Payable' ? '' : 'Payable') }}>
                    <span className={commoncss.label6}>Payable</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Payable' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Payable</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}

              {activePlandata?.includes('Sales') ?
                (
                  <div className={` ${registerscss.registerTypeDiv} ${selectedValue === 'Sales' ? registerscss.registerTypeDivActive : ''}`} onClick={() => { handleChange(selectedValue === 'Sales' ? '' : 'Sales') }}>
                    <span className={commoncss.label6}>Sales</span>
                    <span className={registerscss.registerTypeStat}>
                      {selectedValue === 'Sales' ? <RadioChecked width={17} height={16} /> : <RadioUnchecked width={17} height={16} />}
                    </span>
                  </div>
                ) : (
                  <div className={registerscss.registerTypeDiv}>
                    <span className={commoncss.label6}>Sales</span>
                    <span className={registerscss.registerTypeStat}><RadioUnchecked width={17} height={16} /></span>
                  </div>
                )}
            </div>
          </>
        </div>
      </Modal>
      {/* 
    
      <Modal
        open={registerModalOpen}
        onClose={handleRegisterModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box className="wp-modal-box wp-modal-box-select-ir">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h5
              className="wp-add-comp-modal-header font-sans"
              style={{ display: "inline-block" }}
            >
              Select Register Type
            </h5>
            <div

              className="wp-modal-box-select-ir-closebtn"
              onClick={handleRegisterModalClose}
              style={{ cursor: "pointer" }}>
              <span style={{ cursor: "pointer" }} className="font-sans">Close</span>

            </div>
          </Typography>
          <p className="wp-add-comp-modal-p">
            Select from the registers to prepare reporting and consolidating
            financial statements
          </p>
          <div className="row">
            {activePlandata?.includes('Investment') ?
              (<div className="col-4">
                <Card
                  className={`register-modal-card ${selectedValue === "a" ? "register-modal-card-active" : ""
                    }`}
                >
                  <CardContent>
                    <Radio
                      checked={selectedValue === "a"}
                      onChange={handleChange}
                      value="a"
                      disabled={permissions?.companyData[0]?.components[1]?.permission?.create === false}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans"
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      Investment
                    </Typography>
                  </CardContent>
                </Card>
              </div>)
              :
              (<div className="col-4">
                <Card
                  className={`register-modal-card ${selectedValue === "a" ? "register-modal-card-active" : ""
                    }`}
                >
                  <CardContent>
                    <Radio
                      checked={selectedValue === "a"}
                      onChange={handleChange}
                      value="a"
                      disabled
                      // disabled={permissions?.companyData[0]?.components[0]?.permission?.create === false}
                      name="radio-buttons"
                      inputProps={{ "aria-label": "A" }}
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans"
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      Investment
                    </Typography>
                  </CardContent>
                </Card>
              </div>)}

            {activePlandata?.includes('Loan') ? (
              <div className="col-4">
                <Card
                  className={`register-modal-card ${selectedValue === "b" ? "register-modal-card-active" : ""
                    }`}
                >
                  <CardContent>
                    <Radio
                      checked={selectedValue === "b"}
                      onChange={handleChange}
                      value="b"
                      name="radio-buttons"
                      inputProps={{ "aria-l abel": "B" }}
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans "
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      Loans
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ) :
              (<div className="col-4">
                <Card
                  className={`register-modal-card ${selectedValue === "b" ? "register-modal-card-active" : ""
                    }`}
                >
                  <CardContent>
                    <Radio
                      checked={selectedValue === "b"}
                      onChange={handleChange}
                      value="b"
                      name="radio-buttons"
                      disabled
                      inputProps={{ "aria-l abel": "B" }}
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans "
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      Loans
                    </Typography>
                  </CardContent>
                </Card>
              </div>)}

            {activePlandata?.includes('Purchases') ? (<div className="col-4">
              <Card className={`register-modal-card ${selectedValue === "c" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "c"}
                    onChange={handleChange}
                    value="c"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "C" }}

                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Purchase
                  </Typography>
                </CardContent>
              </Card>
            </div>) : (<div className="col-4">
              <Card className="register-modal-card">
                <CardContent>
                  <Radio
                    checked={selectedValue === "c"}
                    onChange={handleChange}
                    value="c"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "C" }}
                    disabled
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Purchase
                  </Typography>
                </CardContent>
              </Card>
            </div>)}

            {activePlandata?.includes('Leases') ? (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card
                className={`register-modal-card ${selectedValue === "d" ? "register-modal-card-active" : ""
                  }`}
              >
                <CardContent>
                  <Radio
                    checked={selectedValue === "d"}
                    onChange={handleChange}
                    value="d"
                    disabled={permissions?.companyData[0]?.components[3]?.permission?.create === false}
                    name="radio-buttons"
                    inputProps={{ "aria-label": "D" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Lease
                  </Typography>
                </CardContent>
              </Card>
            </div>) :
              (<div className="col-4" style={{ marginTop: "20px" }}>
                <Card
                  className={`register-modal-card ${selectedValue === "d" ? "register-modal-card-active" : ""
                    }`}
                >
                  <CardContent>
                    <Radio
                      checked={selectedValue === "d"}
                      onChange={handleChange}
                      value="d"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "D" }}
                      disabled
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans "
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      Lease
                    </Typography>
                  </CardContent>
                </Card>
              </div>)}

            {activePlandata?.includes('Fixed Assets') ? (
              <div className="col-4" style={{ marginTop: "20px" }}>
                <Card
                  className={`register-modal-card ${selectedValue === "e" ? "register-modal-card-active" : ""
                    }`}
                >
                  <CardContent>
                    <Radio
                      checked={selectedValue === "e"}
                      onChange={handleChange}
                      value="e"
                      name="radio-buttons"
                      inputProps={{ "aria-l abel": "E" }}
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans "
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      FAR
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ) : (
              <div className="col-4" style={{ marginTop: "20px" }}>
                <Card className="register-modal-card">
                  <CardContent>
                    <Radio
                      checked={selectedValue === "e"}
                      onChange={handleChange}
                      value="e"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "E" }}
                      disabled
                      sx={{
                        color: "#03565A",
                        '&.Mui-checked': {
                          color: "#03565A",
                        },
                      }}
                    />
                    <Typography
                      className="wp-comp-added-p font-sans "
                      style={{ paddingTop: "12px", paddingBottom: "20px" }}
                    >
                      FAR
                    </Typography>
                  </CardContent>
                </Card>
              </div>)}

            {activePlandata?.includes('Receivables') ? (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card className={`register-modal-card ${selectedValue === "f" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "f"}
                    onChange={handleChange}
                    value="f"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "F" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Receivable
                  </Typography>
                </CardContent>
              </Card>
            </div>) : (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card className={`register-modal-card ${selectedValue === "f" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "f"}
                    onChange={handleChange}
                    value="f"
                    name="radio-buttons"
                    disabled
                    inputProps={{ "aria-label": "F" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Receivable
                  </Typography>
                </CardContent>
              </Card>
            </div>)}

            {activePlandata?.includes('Payables') ? (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card className={`register-modal-card ${selectedValue === "g" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "g"}
                    onChange={handleChange}
                    value="g"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "G" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Payable
                  </Typography>
                </CardContent>
              </Card>
            </div>) : (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card className={`register-modal-card ${selectedValue === "g" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "g"}
                    onChange={handleChange}
                    value="g"
                    name="radio-buttons"
                    disabled
                    inputProps={{ "aria-label": "G" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Payable
                  </Typography>
                </CardContent>
              </Card>
            </div>)}
            {activePlandata?.includes('Sales') ? (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card className={`register-modal-card ${selectedValue === "h" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "h"}
                    onChange={handleChange}
                    value="h"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "H" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Sales
                  </Typography>
                </CardContent>
              </Card>
            </div>) : (<div className="col-4" style={{ marginTop: "20px" }}>
              <Card className={`register-modal-card ${selectedValue === "h" ? "register-modal-card-active" : ""
                }`}>
                <CardContent>
                  <Radio
                    checked={selectedValue === "h"}
                    onChange={handleChange}
                    value="h"
                    name="radio-buttons"
                    disabled
                    inputProps={{ "aria-label": "H" }}
                    sx={{
                      color: "#03565A",
                      '&.Mui-checked': {
                        color: "#03565A",
                      },
                    }}
                  />
                  <Typography
                    className="wp-comp-added-p font-sans "
                    style={{ paddingTop: "12px", paddingBottom: "20px" }}
                  >
                    Sales
                  </Typography>
                </CardContent>
              </Card>
            </div>)}

          </div>

          <div className="blankspace20"></div>
          <div className="row">
            <div className="col-12 text-center">
              <a id="linkA" href="#" style={{ display: "none" }}></a>
              <a id="linkC" href="#" style={{ display: "none" }}></a>
              <a id="linkE" href="#" style={{ display: "none" }}></a>
              <a id="linkH" href="#" style={{ display: "none" }}></a>
              <a
                id="linkB"
                href="https://loan.test.myfinalyst.com"
                rel="noreferrer"
              ></a>
              <a
                id="linkD"
                href={process.env.REACT_APP_LEASE_FRONTEND_URL}
                rel="noreferrer"
              ></a>
              <a
                id="linkF"
                href="https://receivable.test.myfinalyst.com"
                rel="noreferrer"
              >
              </a>
              <a
                id="linkG"
                href="https://payable.test.myfinalyst.com"
                rel="noreferrer"
              >
              </a>
              <button
                className="wp-btn-fill"
                onClick={() => {
                  Chnageradiofunction();
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    */}

    </>
  );
};
export default RegisterModal;
